import React from "react";
import { createRoot } from "react-dom/client";
import * as serviceWorker from "./serviceWorker";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import App from "./App";
import "./index.css";
// Redeploy trigger: 2026-09-15

// eslint-disable-next-line react/no-deprecated
createRoot(document.getElementById("root")!).render(
  <>
    <App />
  </>
);
//   ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.unregister();
